import React, { useState } from 'react';

const EMPTY_FILTER = {
  regNo:        '',
  patientName:  '',
  startDate:    '',
  endDate:      '',
  place:        '',
  reportStatus: '',
};

export default function FilterModal({ onClose, onApply, onClear, initialData }) {
  const [filter, setFilter] = useState(initialData || EMPTY_FILTER);

  const handleClear = () => {
    setFilter(EMPTY_FILTER);
    if (typeof onClear === 'function') onClear();
  };

  const handleFilter = () => {
    if (typeof onApply === 'function') onApply(filter);
    onClose();
  };

  return (
    <div className="dcm__overlay" onClick={onClose}>
      <div
        className="dcm__modal-container"
        style={{ maxWidth: 700 }}
        onClick={e => e.stopPropagation()}
      >
        <div className="dcm__bg" />
        <div className="dcm__bg-tint" />

        <div className="dcm__content">

          {/* Header */}
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h5 className="fw-bold mb-0 dcm__title" style={{ fontSize: '1.4rem' }}>
              Dashboard filter
            </h5>
            <button className="dcm__close-btn" onClick={onClose}>X</button>
          </div>

          {/* Row 1: Patient Reg No | Patient Name */}
          <div className="row g-3 mb-3">
            <div className="col-12 col-sm-6">
              <label className="form-label fw-semibold small">Patient  Reg No</label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter a Patient Reg No"
                value={filter.regNo}
                maxLength={50}
                onChange={e => setFilter(p => ({
                  ...p,
                  regNo: e.target.value.replace(/[^0-9]/g, '').slice(0, 50),  // numbers only, max 50
                }))}
              />
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label fw-semibold small">Patient Name</label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter a Patient name"
                value={filter.patientName}
                maxLength={50}
                onChange={e => setFilter(p => ({
                  ...p,
                  patientName: e.target.value.replace(/[^a-zA-Z\s]/g, '').slice(0, 50),  // alphabets + space only, max 50
                }))}
              />
            </div>
          </div>

          {/* Row 2: Start Date | End Date */}
          <div className="row g-3 mb-3">
            <div className="col-12 col-sm-6">
              <label className="form-label fw-semibold small">Start Date</label>
              <div style={{ position: 'relative' }}>
                <input
                  className="form-control"
                  type="date"
                  value={filter.startDate}
                  maxLength={50}
                  onChange={e => setFilter(p => ({ ...p, startDate: e.target.value }))}
                  style={{ paddingLeft: '2.5rem', cursor: 'pointer' }}
                />
                <i
                  className="fa-regular fa-calendar"
                  style={{
                    position: 'absolute', left: '0.75rem', top: '50%',
                    transform: 'translateY(-50%)', color: '#aaa',
                    pointerEvents: 'none',
                  }}
                />
              </div>
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label fw-semibold small">End Date</label>
              <div style={{ position: 'relative' }}>
                <input
                  className="form-control"
                  type="date"
                  value={filter.endDate}
                  min={filter.startDate || undefined}
                  maxLength={50}
                  onChange={e => setFilter(p => ({ ...p, endDate: e.target.value }))}
                  style={{ paddingLeft: '2.5rem', cursor: 'pointer' }}
                />
                <i
                  className="fa-regular fa-calendar"
                  style={{
                    position: 'absolute', left: '0.75rem', top: '50%',
                    transform: 'translateY(-50%)', color: '#aaa',
                    pointerEvents: 'none',
                  }}
                />
              </div>
            </div>
          </div>

          {/* Row 3: Scanning Place | Report Status */}
          <div className="row g-3 mb-4">
            <div className="col-12 col-sm-6">
              <label className="form-label fw-semibold small">Scaning Place</label>
              <input
                className="form-control"
                type="text"
                placeholder="Enter scaning place"
                value={filter.place}
                maxLength={50}
                onChange={e => setFilter(p => ({
                  ...p,
                  place: e.target.value.replace(/[^a-zA-Z\s]/g, '').slice(0, 50),  // alphabets + space only, max 50
                }))}
              />
            </div>
            <div className="col-12 col-sm-6">
              <label className="form-label fw-semibold small">Report Status</label>
              <select
                className="form-select"
                value={filter.reportStatus}
                onChange={e => setFilter(p => ({ ...p, reportStatus: e.target.value }))}
              >
                <option value="">All</option>
                <option value="1">BI-RADS 1</option>
                <option value="2">BI-RADS 2</option>
                <option value="3">BI-RADS 3</option>
                <option value="4">BI-RADS 4</option>
                <option value="5">BI-RADS 5</option>
              </select>
            </div>
          </div>

          {/* Actions */}
          <div className="d-flex justify-content-end gap-2">
            <button className="btn dcm__btn-cancel px-4" onClick={handleClear}>
              Clear
            </button>
            <button className="btn dcm__btn-delete px-4" onClick={handleFilter}>
              Filter
            </button>
          </div>

        </div>
      </div>

      {/* Calendar icon cursor fix */}
      <style>{`
        input[type="date"]::-webkit-calendar-picker-indicator {
          opacity: 0;
          position: absolute;
          right: 0;
          top: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
}